module.exports = __webpack_public_path__ + "img/series-7.41ad1b4d.png";